import React from "react";
const Pic =()=>{
   return(
    <div style={{width: "100%"}}>
      <img src={'https://images.mastersunion.link/uploads/25082025/v1/blackLogoMu.svg'} alt="" style={{width: "20%"}} />
    </div>
   )
}

export default Pic 